<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P0003606.controle.mode' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <app-mode-control-multiple
      [datas]="[
        {
          ref: 0,
          label: 'P0003607.dashboard.off' | translate,
          icon: 'fa-kit fa-picto-off',
          color: 'color-danger',
        },
        {
          ref: 1,
          label: 'P0003607.dashboard.horl' | translate,
          icon: 'fa-kit fa-picto-horloge',
          color: 'color-orange',
        },
        {
          ref: 2,
          label: 'P0003607.dashboard.regul' | translate,
          icon: 'fa-kit fa-picto-programme',
          color: 'color-orange',
        },
        {
          ref: 3,
          label: 'P0003607.dashboard.on' | translate,
          icon: 'fa-kit fa-picto-on',
          color: 'color-green',
        },
      ]"
      [value]="this.actionStack!.getValue('esCModeFonctionnement')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.ElectrolyseurStandard_Controle,
          'esCModeFonctionnement',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-multiple>
  </div>
</div>
